import { render, staticRenderFns } from "./page-career-resources.vue?vue&type=template&id=65ff8ba9"
import script from "./page-career-resources.vue?vue&type=script&lang=js"
export * from "./page-career-resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports